module.exports = __webpack_public_path__ + "img/1460825120.6a455e05.jpg";